export default __webpack_public_path__ + "static/media/vehelix_upload_01.d6a252e8.svg";